// OverlayPassShader.js

'use strict'


var glslify = require('glslify');


var OverlayPassShader = {

  transparent: true,

  blending: 2,

  depthTest: false,

  depthWrite: false,

  side: 2,

  uniforms: {
    'tDiffuse': { type: 't', value: null },
    'opacity': { type: 'f', value: 1 },
  },

  vertexShader: glslify('./PassShader.vert'),

  fragmentShader: glslify('./OverlayPassShader.frag')

};

module.exports = OverlayPassShader;
